import BTSession from '../pages/session';
import EvvVerification from '../pages/session/evvVerification/EvvVerification';
import SessionReview from '../components/layout/qa/session-review';
import { Roles } from '../constants';

export const sessionRoutes = [
  {
    path: '/evv/verify',
    type: 'public',
    elem: <EvvVerification />,
    roles: [],
  },
  {
    path: '/new-session',
    type: 'private',
    elem: <BTSession />,
    roles: [Roles.Prbt, Roles.Admin, Roles.Vbt, Roles.Bcba],
  },
  {
    path: '/sessions/:id',
    type: 'private',
    elem: <BTSession />,
    roles: [
      Roles.Prbt,
      Roles.Admin,
      Roles.Bcba,
      Roles.AssistantAssessor,
      Roles.ClientSuccessManager,
      Roles.Biller,
      Roles.InvoiceCoordinator,
      Roles.QaSpecialist,
      Roles.Guardian,
      Roles.Vbt,
      Roles.LimitedAccessGuardian,
    ],
  },
  {
    path: '/sessions/:id/review',
    type: 'private',
    elem: <SessionReview />,
    roles: [
      Roles.Prbt,
      Roles.Admin,
      Roles.Bcba,
      Roles.AssistantAssessor,
      Roles.ClientSuccessManager,
      Roles.Biller,
      Roles.InvoiceCoordinator,
      Roles.QaSpecialist,
      Roles.Vbt,
    ],
  },
];
